<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="affiliate-bonuses-modal" :title="$t('frontend_affiliate_promos_affiliate_bonuses')" width="1120px" max-width="1120px">
    <affiliate-workspace :sections="affiliateBonusesTabs" :current="affiliateBonusesTab" label="Products with affiliate bonuses" @select="handleAffiliateBonusTabChange">
      <header class="gs-aff-panel-head"><div><h2>Bonuses by price point</h2><p>Choose the bonuses buyers receive when they purchase through your link.</p></div></header>
      <div v-for="bonus in affiliateBonuses" :key="bonus.product_id">
        <div v-if="affiliateBonusesTab === 'affiliate_bonus_' + bonus.product_id" class="gs-aff-link-list">
          <section v-for="pricePoint in bonus.pricepoints" :key="pricePoint.id" class="gs-aff-link-card gs-aff-form">
            <label>{{ pricePoint.pricepoint_name }}
              <multi-select :id="'affiliate-bonus-' + pricePoint.id" v-model="pricePoint.bonuses" track-by="id" label="name" :placeholder="$t('frontend_affiliate_promos_add_your_bonuses')" :options="bonuses" :searchable="true" :multiple="true" :allow-empty="true" :close-on-select="true" />
            </label>
          </section>
          <p v-if="!bonus.pricepoints.length" class="gs-aff-empty">No price points are available for this product.</p>
        </div>
      </div>
      <p v-if="!affiliateBonuses.length" class="gs-aff-empty">No affiliate bonuses are available for this promotion.</p>
    </affiliate-workspace>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'affiliate-bonuses-modal')">{{ $t('frontend_close') }}</gs-button>
      <gs-button variant="primary" @click="saveAffiliateBonuses()">{{ $t('frontend_save') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
import AffiliateBonus from '@/models/AffiliateBonus';

export default {
    components: { AffiliateWorkspace },
    props: {
        affiliateBonuses: {
            required: true,
        },
        bonuses: {
            required: true,
        },
        affiliateBonusesTab: {
            required: true,
        },
    },
    computed: {
        affiliateBonusesTabs() {
            const affiliateBonusTabs = [];
            for (let i = 0; i < this.affiliateBonuses.length; i++) {
                affiliateBonusTabs.push({
                    title: this.affiliateBonuses[i].product_name,
                    value: `affiliate_bonus_${this.affiliateBonuses[i].product_id}`,
                });
            }

            return affiliateBonusTabs;
        },
    },
    methods: {
        handleAffiliateBonusTabChange(newTab) {
            this.$emit('affiliate-bonuses-tab-change', newTab)
        },
        async saveAffiliateBonuses() {
            this.$loader.start('saveAffiliateBonuses');
            for (let i = 0; i < this.affiliateBonuses.length; i++) {
                const pricePoints = this.affiliateBonuses[i].pricepoints;

                for (let j = 0; j < pricePoints.length; j++) {
                    const affiliateBonusId = pricePoints[j].id;
                    const affiliateBonus = await AffiliateBonus.$find(affiliateBonusId);
                    affiliateBonus.bonuses = pricePoints[j].bonuses;
                    await affiliateBonus.save();
                }
            }

            this.$loader.end('saveAffiliateBonuses');
            this.$root.$emit('modal-close', 'affiliate-bonuses-modal');
        },
    }
}
</script>
